module.exports = "https://www.niulinkcloud.cn/_next/static/media/shipinhao.5b392278de3bf1825ab0e03e149c9cb1.png";